import React from "react";
import arrowLeft from "../Icons/arrowLeft.svg";
import arrowRight from "../Icons/arrowRight.svg";
import "./ShowButton.scss";

/**
 * A button to show the best spots or the day picker
 */

const ShowButton = (props) => {
  return (
    <div
      id={props.pointLeft ? "bestSpotsButton" : "dayPickerButton"}
      onClick={props.show}
      style={{ display: props.hide && "none" }}
    >
      <div className="fizzButton">
        <img src={props.pointLeft ? arrowLeft : arrowRight} alt="show button" />
      </div>
    </div>
  );
};

export default ShowButton;
